<template>
  <div class="col-12 fetchedText">
    <div class="table-fluid">
      <ul class="search-table" v-for="(nnyafter,index) in NnyLemAfter" v-if="NnyLemAfter" :key="nnyafter.text+'-'+index">
        <li class="col-12">
          <dl class="row">
            <dt
              class="col-6 col-lg-3 col-sm-4 bold-text"
              v-bind:class="[isPictureView ? 'backgrd':'' ]"
            >
              <span class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
              >{{$t('message.lemma')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="LEM"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <b v-html="nnyafter.text" :ref="'link34'+index"></b>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="NnyUttAfter && index==index1" v-for="(utt,index1) in uttafter" :key="utt+'-'+index1">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text utt-text"
              data-type="UTT"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
              v-html="utt"
            ></dd>
          </dl>
        </li>
      </ul>
      <ul class="search-table">
        <li class="col-12" v-if="NnyLem">
          <dl class="row">
            <dt
              class="col-6 col-lg-3 col-sm-4 bold-text"
              v-bind:class="[isPictureView ? 'backgrd':'' ]"
            >
              <span class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
              >{{$t('message.lemma')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="LEM"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <b v-html="NnyLem.text" ref="link1"></b>&nbsp;
              <!-- <span v-for="(img,index) in imgs" :key="img[0]+'-'+index">
                <img alt=""
                  v-on:click="getImage(imgs[index], extractContent(NnyLem.text.replace('|','')), NnyLem.id, displayLang)"
                  class="pointer"
                  src="/images/image-link.png"
                >&nbsp;
              </span> -->
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img  class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="NnyUtt">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text utt-text"
              data-type="UTT"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
              v-html="NnyUtt.text.includes('&&')?getUttText(NnyUtt.text.split('&&')[0]):getUttText(NnyUtt.text)"
            ></dd>
          </dl>
        </li>
        <li class="col-12" v-if="NnyKat">
          <dl
            class="row"
            v-if="NnyKat.text.includes('&&')"
            v-for="(nnykat,index) in NnyKat.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
            :key="nnykat+'-'+index"
          >
            <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="KAT"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="nnykat" ref="link2"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img  class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
          <dl class="row" v-else>
            <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="KAT"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span
                v-html="NnyKat.text.includes(';')?NnyKat.text.split(';')[1]:NnyKat.text"
                ref="link2"
              ></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img  class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="bLem">
          <dl class="row">
            <dt
              class="col-6 col-lg-3 col-sm-4 bold-text"
              v-bind:class="[isPictureView ? 'backgrd':'' ]"
            >
              <span class="dynamic">{{ $t('message.english')}}</span>
              <span
                v-if="NnyLem===undefined"
                v-bind:class="[isPictureView ? 'nor-text-picture bold ':'nor-text-new' ]"
              >{{$t('message.lemma')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text"
              data-type="LEM"
              :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
            >
              <b v-html="bLem.text" ref="link3"></b>&nbsp;
              <!-- <span v-if="(bLem.text === NnyLem.text.replace('|',''))"><span v-for="(img,index) in imgs" :key="img[0]+'-'+index">
                <img alt=""
                  v-on:click="getImage(imgs[index], extractContent(NnyLem.text.replace('|','')), NnyLem.id, displayLang)"
                  class="pointer"
                  src="/images/image-link.png"
                >&nbsp;
              </span>
              </span> -->
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="bKat">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text"
              data-type="KAT"
              :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
              v-html="bKat.text.includes(';')?bKat.text.split(';')[1]:bKat.text"
              ref="link4"
            ></dd>
          </dl>
        </li>
        <li class="col-12" v-if="lastLem">
          <dl class="row">
            <dt
              class="col-6 col-lg-3 col-sm-4 bold-text"
              v-bind:class="[isPictureView ? 'backgrd':'' ]"
              style="text-transform: capitalize;"
            >
              <span class="dynamic">{{ secondLang }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 font-thin"
              data-type="LEM"
              :lang="languageCodeList.find(x=>x.lang==lastLem.lang).langISOCode"
              v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
            >
              <b v-html="lastLem.text" ref="link5"></b>
              <a role="button"  href="javascript:void(0)" v-if="lastLem.lang === 'N' || lastLem.lang === 'E'" onclick="javascript:tts(this);">
                <img
                    class="pointer speaker-image"
                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                  >
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="lastUtt && lastLem">
          <dl class="row">
            <dt class="col-lg-3 col-sm-4 col-6 bold-text"></dt>
            <dd
              class="col-lg-9 col-sm-8 col-6 nor-text utt-text"
              data-type="UTT"
              :lang="languageCodeList.find(x=>x.lang==lastUtt.lang).langISOCode"
              v-html="lastUtt.text"
            ></dd>
          </dl>
        </li>
        <li class="col-12" v-if="lastkat && lastLem">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text"></dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 font-thin"
              data-type="KAT"
              :lang="languageCodeList.find(x=>x.lang==lastkat.lang).langISOCode"
              v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
              v-html="lastkat.text.includes(';')?lastkat.text.split(';')[1]:lastkat.text"
              ref="link6"
            ></dd>
          </dl>
        </li>
        <li class="col-12" v-if="NnyAlt" v-for="(alts,index) in NnyAlt" :key="alts.text+'-'+index">
          <dl
            class="row"
            v-if="alts.text.includes('&&')"
            v-for="(alt,index1) in alts.text.split('&&').filter(x=>x.match('[^ -]')&& x.length != 0).reverse()"
            :key="alt+'-'+index1"
          >
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span v-if="index1==0" class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                v-if="index==0 && index1===0"
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.alternative')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="ALT"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="alt" ref="link7"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
          <dl class="row" v-else>
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                v-if="index==0"
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.alternative')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="ALT"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="alts.text" ref="link7"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img  class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="bAlt">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.english')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="ALT"
              :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
              v-html="bAlt.text"
              ref="link8"
            >
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img  class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="lastAlt">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ secondLang }}</span>
              <span
                v-if="(lastAlt.lang === 'N' || lastAlt.lang === 'E') && !NnyAlt.length"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.alternative')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 clsE"
              v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
              data-type="ALT"
              :lang="languageCodeList.find(x=>x.lang==lastAlt.lang).langISOCode"
            >
            <span v-html="lastAlt.text" ref="link9"></span>
            <a role="button" href="javascript:void(0)" v-if="lastAlt.lang === 'N' || lastAlt.lang === 'E'" onclick="javascript:tts(this);">
              <img
                class="pointer speaker-image"
                :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
              >
            </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="NnyMor">
          <dl
            v-if="NnyMor.text.includes('&&')"
            class="row"
            v-for="(nnymor,index) in NnyMor.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
            :key="nnymor+'-'+index"
          >
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span v-if="index===0" class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                v-if="index===0 "
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.morphology')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              :data-lemma='NnyLem'
              data-type="MOR"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="'['+nnymor+']'" :ref="'link35'+index"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
          <dl class="row" v-else>
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.morphology')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              :data-lemma='NnyLem'
              data-type="MOR"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="'['+NnyMor.text+']'" ref="link10"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="bMor">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.english')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              :data-lemma='bLem'
              data-type="MOR"
              :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
              v-html="bMor.text"
              ref="link11"
            >
            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
              <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg" >
            </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="lastMor">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ secondLang }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 clsE"
              v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
              data-type="MOR"
              :data-lemma='lastLem'
              :lang="languageCodeList.find(x=>x.lang==lastMor.lang).langISOCode"
            >
            <span v-if="lastMor.lang === 'N' || lastMor.lang === 'E'"
                  v-html="'['+lastMor.text+']'" ref="link12">
            </span>
            <span v-else v-html="lastMor.text" ref="link12"></span>
            <a role="button" href="javascript:void(0)" v-if="lastMor.lang === 'N' || lastMor.lang === 'E'" onclick="javascript:tts(this);">
              <img
                class="pointer speaker-image"
                :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                >
            </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="NnyKom">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.comment')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="KOM"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="NnyKom.text" ref="link13"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
              <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="bKom">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.english')}}</span>
              <span
                v-if="NnyKom===undefined"
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.comment')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="KOM"
              :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
              v-html="bKom.text"
              ref="link14"
            >
            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
              <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
            </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="lastKom">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ secondLang }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 clsE"
              data-type="KOM"
              v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
              :lang="languageCodeList.find(x=>x.lang==lastKom.lang).langISOCode"
            >
            <span v-html="lastKom.text" ref="link15"></span>
            <a role="button" href="javascript:void(0)" v-if="lastKom.lang === 'N' || lastKom.lang === 'E'" onclick="javascript:tts(this);">
              <img
                class="pointer speaker-image"
                :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
              >
            </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="NnyGrm">
          <dl
            class="row"
            v-if="NnyGrm.text.includes('&&')"
            v-for="(nnygrm,index) in NnyGrm.text.split('&&').filter(x=>x.match('[^ -]')).reverse().filter(function(el) {return el.length != 0})"
            :key="nnygrm+'-'+index"
          >
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span v-if="index===0 " class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                class="reg-text"
                v-if="index===0 "
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.grammar')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="GRM"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="nnygrm" ref="link16"></span>
              <a role = "button" href="javascript:void(0)" onclick="javascript:tts(this);">
               <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
          <dl class="row" v-else>
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.grammar')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="GRM"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="NnyGrm.text" ref="link16"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="bGrm">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.english')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="GRM"
              :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
              v-html="bGrm.text"
              ref="link17"
            >
            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
              <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
            </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="lastGrm">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ secondLang }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 clsE"
              v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
              data-type="GRM"
              :lang="languageCodeList.find(x=>x.lang==lastGrm.lang).langISOCode"
            >
            <span v-html="lastGrm.text" ref="link18"></span>
            <a role="button" href="javascript:void(0)" v-if="lastGrm.lang === 'N' || lastGrm.lang === 'E'" onclick="javascript:tts(this);">
              <img
                class="pointer speaker-image"
                :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
              >
            </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="NnyDef">
          <dl
            class="row"
            v-if="((NnyDef.text.includes('&&')))"
            v-for="(nnydef,index) in NnyDef.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
            :key="nnydef+'-'+index"
          >
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span v-if="index === 0" class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                class="reg-text"
                v-if="index===0"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.explanation') }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsN"
              data-type="DEF"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="nnydef" :ref="'link36'+index"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img  class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
          <dl class="row" v-else>
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.explanation') }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsN"
              data-type="DEF"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="NnyDef.text" ref="link19"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="bDef">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.english')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text"
              data-type="DEF"
              v-html="bDef.text"
              :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
              ref="link20"
            ></dd>
          </dl>
        </li>
        <li class="col-12" v-if="lastDef">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ secondLang }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8"
              data-type="DEF"
              :lang="languageCodeList.find(x=>x.lang==lastDef.lang).langISOCode"
              v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
            >
             <span v-html="lastDef.text" ref="link21"></span>
            <a role="button" href="javascript:void(0)" v-if="lastDef.lang === 'N' || lastDef.lang === 'E'" onclick="javascript:tts(this);">
              <img
                class="pointer speaker-image"
                :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                >
            </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="NnyTil">
          <dl
            class="row"
            v-if="((NnyTil.text.includes('&&')))"
            v-for="(nnytil,index) in NnyTil.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
            :key="nnytil+'-'+index"
          >
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span v-if="index===0" class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                v-if="index===0"
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.addition') }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsN"
              data-type="TIL"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="nnytil" ref="link22"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
          <dl class="row" v-else>
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.nynorsk')}}</span>
              <span
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{ $t('message.addition') }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsN"
              data-type="TIL"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="NnyTil.text" ref="link22"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="bTil">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ $t('message.english')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsN"
              data-type="TIL"
              :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
              v-html="bTil.text"
              ref="link23"
            >
            <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
              <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
            </a>
            </dd>
          </dl>
        </li>
        <li class="col-12" v-if="lastTil">
          <dl class="row">
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span class="dynamic">{{ secondLang }}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 clsN"
              v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
              data-type="TIL"
              :lang="languageCodeList.find(x=>x.lang==lastTil.lang).langISOCode"
            >
            <span v-html="lastTil.text" ref="link24"></span>
            <a role="button" href="javascript:void(0)" v-if="lastTil.lang === 'N' || lastTil.lang === 'E'" onclick="javascript:tts(this);">
              <img class="pointer speaker-image"
                :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                >
            </a>
            </dd>
          </dl>
        </li>
        <hr v-if="eks.length || idi.length || sms.length">
        <li class="col-12" v-for="(eks,index) in eks" :key="eks.text+'-'+index">
          <hr v-if="index>0 && (eks.lang==='NNY')">
          <div v-if="((eks.lang==='NNY') && (eks.text.includes('&&')))">
          <dl
            class="row"
            v-for="(ekss,index1) in eks.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
            :key="ekss+'-'+index1"
          >
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span v-if="index1 === 0" class="dynamic">{{$t('message.nynorsk')}}</span>
              <span
                v-if="index1 === 0 && index===0"
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{$t('message.example')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="EKS"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="ekss.replace('~','|')" ref="link37"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
          </div>
          <div v-else>
            <dl class="row" v-if="eks.lang==='NNY'">
              <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                <span class="dynamic">{{$t('message.nynorsk')}}</span>
                <span
                  v-if="index === 0"
                  class="reg-text"
                  v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                >{{$t('message.example')}}</span>
              </dt>
              <dd
                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                data-type="EKS"
                :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
              >
                <span v-html="eks.text" ref="link25"></span>
                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                  <img
                    class="pointer speaker-image"
                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                  >
                </a>
              </dd>
            </dl>
            <dl class="row" v-if="eks.lang==='B'">
              <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                <span class="dynamic">{{$t('message.english')}}</span>
                <span
                  v-if="index === 0"
                  class="reg-text"
                  v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                >{{$t('message.example')}}</span>
              </dt>
              <dd
                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                data-type="EKS"
                :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                v-html="eks.text"
                ref="link26"
              >
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img
                  class="pointer speaker-image"
                  :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                >
              </a>
              </dd>
            </dl>
            <dl class="row" v-else-if="((eks.lang !=='B') && (eks.lang !=='NNY'))">
              <dt
                class="col-6 col-lg-3 col-sm-4 bold-text"
                style="text-transform: capitalize;"
              >
                <span class="dynamic">{{ secondLang }}</span>
              </dt>
              <dd
                class="col-6 col-lg-9 col-sm-8 clsE"
                v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                data-type="EKS"
                :lang="languageCodeList.find(x=>x.lang==eks.lang).langISOCode"
              >
               <span v-html="eks.text" ref="link27"></span>
               <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                  <img
                    v-if="eks.lang === 'N' || eks.lang === 'E'"
                    class="pointer speaker-image"
                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                  >
                </a>
              </dd>
            </dl>
          </div>
        </li>
        <hr v-if="(eks.length && idi.length) || (eks.length && sms.length)">
        <li class="col-12" v-for="(idi,index) in idi" :key="idi.text+'-'+index">
          <hr v-if="index>0 && (idi.lang==='NNY')">
          <div  v-if="((idi.lang==='NNY') && (idi.text.includes('&&')))">
          <dl
            class="row"
            v-for="(idis,index1) in idi.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
            :key="idis+'-'+index1"
          >
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span v-if="index1 === 0" class="dynamic">{{$t('message.nynorsk')}}</span>
              <span
                v-if="index1 === 0 && index===0"
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{$t('message.expression')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="IDI"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-html="idis.replace('~','|')" ref="link38"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
          </div>
          <div v-else>
            <dl class="row" v-if="idi.lang==='NNY'">
              <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                <span class="dynamic">{{$t('message.nynorsk')}}</span>
                <span
                  v-if="index === 0"
                  class="reg-text"
                  v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                >{{$t('message.expression')}}</span>
              </dt>
              <dd
                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                data-type="IDI"
                :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
              >
                <span v-html="idi.text" ref="link28"></span>
                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                  <img
                    class="pointer speaker-image"
                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
                </a>
              </dd>
            </dl>
            <dl class="row" v-if="idi.lang==='B'">
              <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                <span class="dynamic">{{$t('message.english')}}</span>
                <span
                  v-if="index === 0"
                  class="reg-text"
                  v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                >{{$t('message.expression')}}</span>
              </dt>
              <dd
                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                data-type="IDI"
                :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                v-html="idi.text"
                ref="link29"
              >
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img
                  class="pointer speaker-image"
                  :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                >
              </a>
              </dd>
            </dl>
            <dl class="row" v-else-if="((idi.lang!=='B') && (idi.lang!='NNY'))">
              <dt
                class="col-6 col-lg-3 col-sm-4 bold-text"
                style="text-transform: capitalize;"
              >
                <span class="dynamic">{{ secondLang }}</span>
              </dt>
              <dd
                class="col-6 col-lg-9 col-sm-8 clsE"
                v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                data-type="IDI"
                :lang="languageCodeList.find(x=>x.lang==idi.lang).langISOCode"
              >
               <span v-html="idi.text" ref="link30"></span>
               <a role="button" href="javascript:void(0)" v-if="idi.lang === 'N' || idi.lang === 'E'" onclick="javascript:tts(this);">
                  <img
                    class="pointer speaker-image"
                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                  >
                </a>
              </dd>
            </dl>
          </div>
        </li>
        <hr v-if="idi.length && sms.length">
        <li class="col-12" v-for="(sms,index) in sms" :key="sms.text+'-'+index">
          <hr v-if="index>0 && (sms.lang==='NNY')">
          <div v-if="((sms.lang==='NNY') && (sms.text.includes('&&')))">
          <dl
            class="row"
            v-for="(smss,index1) in sms.text.split('&&').filter(x=>x.match('[^ -]')).reverse()"
            :key="smss+'-'+index1"
          >
            <dt class="col-6 col-lg-3 col-sm-4 bold-text">
              <span v-if="index1 === 0" class="dynamic">{{$t('message.nynorsk')}}</span>
              <span
                v-if="index1 === 0 && index===0"
                class="reg-text"
                v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
              >{{$t('message.multiword')}}</span>
            </dt>
            <dd
              class="col-6 col-lg-9 col-sm-8 nor-text clsE"
              data-type="SMS"
              :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
            >
              <span v-if="smss.includes(';')" v-html="smss.split(';')[0]" ref="link40"></span>
              <span v-else v-html="smss" ref="link40"></span>
              <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                <img  class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
              </a>
            </dd>
          </dl>
          </div>
          <div v-else>
            <dl class="row" v-if="sms.lang==='NNY'">
              <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                <span class="dynamic">{{$t('message.nynorsk')}}</span>
                <span
                  v-if="index === 0 "
                  class="reg-text"
                  v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                >{{$t('message.multiword')}}</span>
              </dt>
              <dd
                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                data-type="SMS"
                :lang="languageCodeList.find(x=>x.lang=='NNY').langISOCode"
              >
                <span v-if="sms.text.includes(';')" v-html="sms.text.split(';')[0]" ref="link31"></span>
                <span v-else v-html="sms.text" ref="link31"></span>
                <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                  <img
                    class="pointer speaker-image"
                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                  >
                </a>
              </dd>
            </dl>
            <dl class="row" v-if="sms.lang==='B'">
              <dt class="col-6 col-lg-3 col-sm-4 bold-text">
                <span class="dynamic">{{$t('message.english')}}</span>
                <span
                  v-if="index === 0"
                  class="reg-text"
                  v-bind:class="[isPictureView ? 'nor-text-picture bold':'nor-text-new' ]"
                >{{$t('message.multiword')}}</span>
              </dt>
              <dd
                class="col-6 col-lg-9 col-sm-8 nor-text clsE"
                data-type="SMS"
                :lang="languageCodeList.find(x=>x.lang=='B').langISOCode"
                v-html="sms.text"
                ref="link32"
              >
               <a role="button" href="javascript:void(0)" onclick="javascript:tts(this);">
                  <img
                    class="pointer speaker-image"
                    :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                  >
                </a>
              </dd>
            </dl>
            <dl class="row" v-else-if="((sms.lang!=='B') && (sms.lang !== 'NNY'))">
              <dt
                class="col-6 col-lg-3 col-sm-4 bold-text"
                style="text-transform: capitalize;"
              >
                <span class="dynamic">{{ secondLang }}</span>
              </dt>
              <dd
                class="col-6 col-lg-9 col-sm-8 clsE"
                v-bind:class="[isLeftAllign ? 'urd-text' : 'nor-text']"
                data-type="SMS"
                :lang="languageCodeList.find(x=>x.lang==sms.lang).langISOCode"
              >
                <span v-html="sms.text" :ref="'link33'+index"></span>
                <a role="button" href="javascript:void(0)" v-if="sms.lang === 'N' || sms.lang === 'E'" onclick="javascript:tts(this);">
                  <img
                    class="pointer speaker-image"
                    src="/images/speaker-small.svg"
                  >
                </a>
              </dd>
            </dl>
          </div>
        </li>
        <hr class="bdr-set">
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "pictureResultNny",
  data() {
    return {
      xres: null,
      NnyLem: {},
      NnyLemAfter: [],
      NnyKat: {},
      NnyDef: {},
      NnyKom: {},
      NnyTil: {},
      NnyMor: {},
      NnyAlt: [],
      NnyUtt: {},
      NnyUttAfter: {},
      NnyGrm: {},
      bLem: {},
      bKat: {},
      bDef: {},
      bKom: {},
      bTil: {},
      bMor: {},
      bAlt: {},
      bGrm: {},
      lastLem: {},
      lastKat: {},
      lastDef: {},
      lastKom: {},
      lastTil: {},
      lastMor: {},
      lastAlt: {},
      lastUtt: {},
      lastGrm: {},
      sms: [],
      eks: [],
      idi: [],
      arrStr: [],
      imgs: [],
      uttafter: [],
      isLeftAllign: false,
      isPictureView: false,
      refElements: [],
      languageCodeList:[
          {language:'bokmal',lang:'E',langISOCode:'nb'},
          {language:'bokmal',lang:'N',langISOCode:'nb'},
          {language:'nynorsk',lang:'NNY',langISOCode:'nn'},
          {language:'arabic',lang:'ARA',langISOCode:'ar'},
          {language:'dari',lang:'PRS',langISOCode:'prs'},
          {language:'burmese',lang:'BUR',langISOCode:'my'},
          {language:'kurdish (kurmanji)',lang:'KKU',langISOCode:'kmr'},
          {language:'kurdish (sorani)',lang:'KSO',langISOCode:'ckb'},
          {language:'lithuanian',lang:'LIT',langISOCode:'lt'},
          {language:'persian',lang:'PER',langISOCode:'fa'},
          {language:'polish',lang:'POL',langISOCode:'pl'},
          {language:'russian',lang:'RU',langISOCode:'ru'},
          {language:'somali',lang:'SOM',langISOCode:'so'},
          {language:'tagalog',lang:'TGL',langISOCode:'tl'},
          {language:'tamil',lang:'T',langISOCode:'ta'},
          {language:'thai',lang:'TH',langISOCode:'th'},
          {language:'tigrinya',lang:'TIR',langISOCode:'ti'},
          {language:'turkish',lang:'TUR',langISOCode:'tr'},
          {language:'ukrainsk',lang:'UKR',langISOCode:'uk'},
          {language:'ukrainian',lang:'UKR',langISOCode:'uk'},
          {language:'urdu',lang:'UR',langISOCode:'ur'},
          {language:'vietnamese',lang:'VIE',langISOCode:'vi'},
          {language:'english',lang:'B',langISOCode:'en'}
      ]
    };
  },
  props: {
    Val: Array,
    lang: String,
    secondLang: String,
    displayLang: String,
    loaded: Boolean,
    dictionary: String,
    isPicturepage: Boolean,
    searchInput: {
      type: String,
      default: ""
    }
  },
  mounted() {
    if (this.searchInput === "" || this.searchInput === null) {
      this.isPictureView = true;
    }
    if (this.displayLang === "nynorsk") {
      Array.from(document.querySelectorAll(".dynamic")).forEach(
        a => (a.style.display = "none")
      );
    }
    this.refElements = this.$refs;
    this.addOnClickToHyperlink();
  },
  created() {
    if (this.Val.length) {
      this.xres = this.Val;
      this.mapIntoHtml();
    }
  },
  updated() {
    if (this.displayLang === "nynorsk") {
      Array.from(document.querySelectorAll(".dynamic")).forEach(
        a => (a.style.display = "none")
      );
    }
    this.refElements = this.$refs;
    this.addOnClickToHyperlink();
  },
  watch: {
    Val: function(newVal) {
      this.xres = newVal;
      this.mapIntoHtml();
    }
  },
  methods: {
    //#region function to filter the data into the different objects according to the different types
    //words are mapped to the correct object i.e.eLem,eKat....  based on there type
    filterData(lang) {
      var _this = this;
      this.NnyLem = lang.find(function(obj) {
        if (obj.text.includes("&&")) {
          var index = obj.text.indexOf("&");
          if (index > 0) obj.text = obj.text.substring(0, index);
        }
        return obj.type === "Nny-lem";
      });
      this.NnyLemAfter = _.filter(lang, function(item) {
        return _.includes(item.type, "Nny-lemafter") && item.text.length > 0;
      });

      this.NnyKat = lang.find(function(obj) {
        return obj.type === "Nny-kat" && obj.text.length > 0;
      });
      this.NnyDef = lang.find(function(obj) {
        return obj.type === "Nny-def" && obj.text.length > 0;
      });
      this.NnyKom = lang.find(function(obj) {
        if (obj.type == "Nny-kom" && obj.text.match(/^[a-z]+[-]+[0-9]*$/g)) {
        } else {
          return obj.type === "Nny-kom" && obj.text.length > 0;
        }
      });
      this.NnyTil = lang.find(function(obj) {
        return obj.type === "Nny-til" && obj.text.length > 0;
      });
      this.NnyMor = lang.find(function(obj) {
        return obj.type === "Nny-mor" && obj.text.length > 0;
      });

      this.NnyAlt = _.filter(lang, function(item) {
        return _.includes(item.type, "Nny-alt") && item.text.length > 0;
      });

      this.NnyUtt = lang.find(function(obj) {
        return obj.type === "Nny-utt" && obj.text.length > 0;
      });
      this.NnyUttAfter = lang.find(function(obj) {
        if (obj.text.includes("&&")) {
          return obj.type === "Nny-utt" && obj.text.length > 0;
        }
      });
      this.NnyGrm = lang.find(function(obj) {
        return obj.type === "Nny-grm" && obj.text.length > 0;
      });
      this.bLem = lang.find(function(obj) {
        return obj.type === "B-lem" && obj.text.length > 0;
      });
      this.bKat = lang.find(function(obj) {
        return obj.type === "B-kat" && obj.text.length > 0;
      });
      this.bDef = lang.find(function(obj) {
        return obj.type === "B-def" && obj.text.length > 0;
      });
      this.bKom = lang.find(function(obj) {
        if (obj.type == "B-kom" && obj.text.match(/^[a-z]+[-]+[0-9]*$/g)) {
        } else {
          return obj.type === "B-kom" && obj.text.length > 0;
        }
      });
      this.bTil = lang.find(function(obj) {
        return obj.type === "B-til" && obj.text.length > 0;
      });
      this.bMor = lang.find(function(obj) {
        return obj.type === "B-mor" && obj.text.length > 0;
      });
      this.bAlt = lang.find(function(obj) {
        return obj.type === "B-alt" && obj.text.length > 0;
      });
      this.bGrm = lang.find(function(obj) {
        return obj.type === "B-grm" && obj.text.length > 0;
      });

      this.lastLem = lang.find(function(obj) {
        if (
          obj.lang == "UR" ||
          obj.lang == "ARA" ||
          obj.lang == "KSO" ||
          obj.lang == "PER" ||
          obj.lang == "PRS"
        ) {
          _this.isLeftAllign = true;
        }
        return (
          obj.type !== "B-lem" &&
          obj.type !== "Nny-lem" &&
          obj.type !== "Nny-lemafter" &&
          obj.type.indexOf("lem") > 0 &&
          obj.text.length > 0
        );
      });
      this.lastkat = lang.find(function(obj) {
        return (
          obj.type !== "B-kat" &&
          obj.type !== "Nny-kat" &&
          obj.type.indexOf("kat") > 0 &&
          obj.text.length > 0
        );
      });
      this.lastDef = lang.find(function(obj) {
        return (
          obj.type !== "B-def" &&
          obj.type !== "Nny-def" &&
          obj.type.indexOf("def") > 0 &&
          obj.text.length > 0
        );
      });

      this.lastKom = lang.find(function(obj) {
        if (
          obj.type !== "B-kom" &&
          obj.type !== "Nny-kom" &&
          obj.type.indexOf("kom") > 0 &&
          obj.text.match(/^[a-z]+[-]+[0-9]*$/g)
        ) {
        } else {
          return (
            obj.type !== "B-kom" &&
            obj.type !== "Nny-kom" &&
            obj.type.indexOf("kom") > 0 &&
            obj.text.length > 0
          );
        }
      });
      this.lastTil = lang.find(function(obj) {
        return (
          obj.type !== "B-til" &&
          obj.type !== "Nny-til" &&
          obj.type.indexOf("til") > 0 &&
          obj.text.length > 0
        );
      });
      this.lastMor = lang.find(function(obj) {
        return (
          obj.type !== "B-mor" &&
          obj.type !== "Nny-mor" &&
          obj.type.indexOf("mor") > 0 &&
          obj.text.length > 0
        );
      });
      this.lastAlt = lang.find(function(obj) {
        return (
          obj.type !== "B-alt" &&
          obj.type !== "Nny-alt" &&
          obj.type.indexOf("alt") > 0 &&
          obj.text.length > 0
        );
      });
      this.lastUtt = lang.find(function(obj) {
        return (
          obj.type !== "B-utt" &&
          obj.type !== "Nny-utt" &&
          obj.type.indexOf("utt") > 0 &&
          obj.text.length > 0
        );
      });
      this.lastGrm = lang.find(function(obj) {
        return (
          obj.type !== "B-grm" &&
          obj.type !== "Nny-grm" &&
          obj.type.indexOf("grm") > 0 &&
          obj.text.length > 0
        );
      });

      this.sms = _.filter(lang, function(item) {
        return _.includes(item.type, "-sms") && item.text.length > 0;
      });
      this.sms = _.sortBy(this.sms, function(o) {
        return o.sub_id;
      });

      this.sms = this.getDistinctValue(this.sms);

      this.eks = _.filter(lang, function(item) {
        return _.includes(item.type, "-eks") && item.text.length > 0;
      });
      this.eks = _.sortBy(this.eks, function(o) {
        return o.sub_id;
      });
      this.eks = this.getDistinctValue(this.eks);

      this.idi = _.filter(lang, function(item) {
        return _.includes(item.type, "-idi") && item.text.length > 0;
      });
      this.idi = _.sortBy(this.idi, function(o) {
        return o.sub_id;
      });
      this.idi = this.getDistinctValue(this.idi);

      if (this.NnyUttAfter != undefined) {
        this.getUttAfterText(this.NnyUttAfter.text);
      }
      if (this.lastUtt != undefined) {
        this.lastUtt.text = this.getUttText(this.lastUtt.text);
      }
    },
    //#endregion

    //#region function to create separate array for all the utt words contains in text if it contains &&
    getUttAfterText(text) {
      if (text.includes("&&")) {
        var a = text.split("&&");
        if (a.length > 1) {
          for (var i = 1; i < a.length; i++) {
            this.uttafter.push(this.getUttText(a[i]));
          }
        }
      }
    },
    //#endregion

    //#region function to reorder the text of type sms,idi,eks according to the sub_id,first-language and second-language
    getDistinctValue(val) {
      var arr_result = [];
      var bok,
        eng,
        last_lang = [];
      var is_eng_pushed=false;
      bok = _.filter(val, function(item) {
        return item.lang === "NNY";
      });
      eng = _.filter(val, function(item) {
        return item.lang === "B";
      });
      last_lang = _.filter(val, function(item) {
        return item.lang !== "NNY" && item.lang !== "B";
      });
      for (var i = 0; i < bok.length; i++) {
        is_eng_pushed=false;
        arr_result.push(bok[i]);
        if (eng.length > 0) {
        for (var j = 0; j < eng.length; j++) {
          if (bok[i].sub_id < eng[j].sub_id && (bok[i+1]==undefined || eng[j].sub_id<bok[i+1].sub_id)) {
            if (
              arr_result[arr_result.length - 1].lang != "B" &&
              arr_result[arr_result.length - 1].lang == "NNY"
            ) {
              is_eng_pushed=true;
              arr_result.push(eng[j]);
              for (var k = 0; k < last_lang.length; k++) {
                 if (eng[j].sub_id < last_lang[k].sub_id &&
                 ((bok[i+1]==undefined || last_lang[k].sub_id<bok[i+1].sub_id) &&
                 (eng[j+1]==undefined || last_lang[k].sub_id<eng[j+1].sub_id))) {

                   if(last_lang[k].lang=='E' || last_lang[k].lang=='N' ){
                      if(bok[i].sub_id > last_lang[k].sub_id){
                            if( arr_result[arr_result.length - 1].lang == "B" ||
                                arr_result[arr_result.length - 1].lang == "NNY" ){
                              arr_result.push(last_lang[k]);
                            }
                      }
                   }
                   else{
                        if(bok[i].sub_id < last_lang[k].sub_id){
                          if( arr_result[arr_result.length - 1].lang == "B" ||
                                arr_result[arr_result.length - 1].lang == "NNY" ){
                              arr_result.push(last_lang[k]);
                            }
                        }
                   }
                }
              }
            }
          }
        }
        }
        if(!is_eng_pushed){
          for (var k = 0; k < last_lang.length; k++) {
            if ((bok[i+1]==undefined || last_lang[k].sub_id<bok[i+1].sub_id)) {
              if(last_lang[k].lang=='E' || last_lang[k].lang=='N'){
                if(bok[i].sub_id > last_lang[k].sub_id &&
                ((bok[i-1]==undefined || last_lang[k].sub_id>bok[i-1].sub_id) &&
                ((bok[i+1]==undefined || last_lang[k].sub_id<bok[i+1].sub_id)))){
                    if (arr_result[arr_result.length - 1].lang == "B" ||
                          arr_result[arr_result.length - 1].lang == "NNY"){
                            arr_result.push(last_lang[k]);
                    }
                 }
              }
              else{
                 if(bok[i].sub_id < last_lang[k].sub_id){
                  if (arr_result[arr_result.length - 1].lang == "B" ||
                          arr_result[arr_result.length - 1].lang == "NNY"){
                            arr_result.push(last_lang[k]);
                    }
                  }
              }
            }
            else{
                if(bok[i].sub_id < last_lang[k].sub_id){
                  if (arr_result[arr_result.length - 1].lang == "B" ||
                          arr_result[arr_result.length - 1].lang == "NNY"){
                            arr_result.push(last_lang[k]);
                          }
                      }
              }
          }
        }
    }
    return arr_result;
    },
    //#endregion

    //#region  function to group all the records from data for particular id.
    mapIntoHtml() {
      var searchWord = this.searchInput.replace(/^\s+|\s+$/g, "").trim();
      var imagethemePage = false;
      if (this.searchInput == "") {
        imagethemePage = true;
      }
      var loaded = this.loaded;
      this.xres = _.map(this.xres, function(group) {
        var split = group.type.split("-");
        if (group.text.includes("||")) {

        } else if (group.text.includes("|")) {
          group.text = group.text.split("|")[1];
        }
        return {
          id: group.id,
          sub_id: group.sub_id,
          text: decode_utf8(
            group.text,
            split.length > 1 ? split[1].toUpperCase() : "",
            imagethemePage,
            loaded
          ),
          type: group.type,
          lang: split[0].toUpperCase(),
          entry: split.length > 1 ? split[1].toUpperCase() : ""
        };
      });

      for (var i = 0; i < this.xres.length; i++) {
        var split = this.xres[i].type.split("-");
        if (
          this.xres[i].text.includes("&&") &&
          this.xres[i].type == "Nny-lem"
        ) {
          var a = this.xres[i].text.split("&&");
          if (a.length >= 2) {
            for (var j = 1; j < a.length; j++) {
              this.xres.push({
                id: this.xres[i].id,
                sub_id: this.xres[i].sub_id,
                text: decode_utf8(
                  a[j],
                  split.length > 1 ? split[1].toUpperCase() : "",
                  imagethemePage
                ),
                type: this.xres[i].type + "after",
                lang: split[0].toUpperCase(),
                entry: split.length > 1 ? split[1].toUpperCase() : ""
              });
            }
          }

          break;
        }
      }

      //#region function to append anchor element to the hyperlinks
      function append_hyperlink(text) {
        var res = text.match(/[\^].[^\^]*[\^]/gi);
        var result = "";
        if (res != null) {
          for (var i = 0; i < res.length; i++) {
            result = res[i].replace(/[/^]/g, "");
            text = text.replace(
              res[i],
              "<a href='javascript:void(0)'>" + result + "</a>"
            );
          }
        }
        return text;
      }
      //#endregion

      //#region function to highlight the text which matches with the searchword
      function HighlightMatchedtext(text, type) {
        searchWord = searchWord.replace("|", "~");
        if (type !== "UTT" && type !== "KAT") {
          var searchregexArray = searchWord
            .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
            .split("");
          for (var i = 0; i < searchregexArray.length; i++) {
            if (
              searchregexArray[i].length > 0 &&
              searchregexArray[i].match(/[^ .*+?^${}()|[\]\\]/i)
            ) {
              searchregexArray[i] = searchregexArray[i] + "(?:~*)?";
            }
          }
          var searchregex = searchregexArray.join("");
          var searchregexp = new RegExp(
            searchregex + "(?![^<>]*(([/\"']|]]|\b)>))",
            "i"
          );
          text = text.replace(
            searchregexp,
            "<span class = 'highlight'>$&</span>"
          );
          return text;
        } else {
          return text;
        }
      }
      //#endregion

      //#region function to call the hyperlink and highlight function on the basis of condition
      function decode_utf8(text, type, imagethemePage, loaded) {
        if (text.includes("^")) {
          text = append_hyperlink(text); //for hyperlink
        }
        if (!imagethemePage && !loaded) {
          text = HighlightMatchedtext(text, type);
        }
        if (text.includes("&&") && text.includes("|")) {
          text = text.split("|")[1];
        }
        //text = text.replace(/~/g, "|");
        //return text;
        text = text.replace(/~/g, "<span class='pipe-class'></span>");
        let parser = new DOMParser();
        let dom = parser.parseFromString('<!doctype html><body>' + text, 'text/html');
        if(dom.body.innerHTML.includes('&amp;')){
          return dom.body.innerHTML.replace(/&amp;/g,'&');
        }
        else{
           return dom.body.innerHTML;
        }
      }
      //#endregion

      this.filterData(this.xres);
    },
    //#endregion

    //#region  function to get the content inside the span tag
    extractContent(s) {
      var span = document.createElement("span");
      span.innerHTML = s;
      return span.textContent || span.innerText;
    },
    //#endregion

    //#region function to send the sms text for picture page
    getName(val) {
      var splitText = val.split(" ")[0];
      splitText = splitText.split(";")[0];
      return splitText;
    },
    //#endregion

    //#region function to redirect to the picture page when clicked on image icon
    getImage(val1, val2, val3, val4) {
      var router= this.$router.resolve({ 
      name: "PictureComponent",
        params: {
          id: val1,
          wordtext: val2,
          wordId: val3,
          lang: val4,
          isScrollTop: true,
          dictionary: this.dictionary
        }
      });
        if(router.location.params.id===this.$route.params.id){
        this.$eventBus.$emit(
                "map-image",
                {
                  id: val1,
                  wordtext: val2,
                  wordId: val3,
                  lang: val4,
                  isScrollTop: true,
                  dictionary: this.dictionary
                }
              );
     }
     else{
         this.$router.push({
        name: "PictureComponent",
        params: {
          id: val1,
          wordtext: val2,
          wordId: val3,
          lang: val4,
          isScrollTop: true,
          dictionary: this.dictionary
        }
      });
     }
    },
    //#endregion

    //#region function to append onclick event to the hyperlinks
    addOnClickToHyperlink() {
      var _this = this;
      var links = [];
      if (this.refElements !== undefined) {
        Object.keys(this.refElements).forEach(key =>
          addlinks(this.refElements[key])
        );
        for (var i = 0; i < links.length; i++) {
          if (links[i].tagName === "A") {
            links[i].addEventListener("click", function(event) {
              _this.$eventBus.$emit(
                "send-temp",
                event.currentTarget.text.trim()
              );
              if (_this.isPicturepage) {
                localStorage.setItem(
                  "searchWord",
                  event.currentTarget.text.trim()
                );
                _this.$router.push({
                  name: "FindwordsComponent",
                  params: { dictionary: _this.dictionary, isSearch: true }
                });
              }
            });
          }
        }
      }
      function addlinks(elm) {
          if (
            elm !== undefined &&
            elm.children !== undefined &&
            elm.children.length !== 0
          ) {
            var arr = elm.children;
            for (var j = 0; j < arr.length; j++) {
              links.push(arr[j]);
            }
          } else if (elm !== undefined) {
            if (elm.length > 0) {
              for (var i = 0; i < elm.length; i++) {
                arr = elm[i].children;
                for (j = 0; j < arr.length; j++) {
                  links.push(arr[j]);
                }
              }
            }
          }
        }
      this.refElements = [];
      links = [];
    },
    //#endregion

    //#region  function to modify the text of type utt on the basis of colon present in the text.
    getUttText(text) {
      var final_text = "";
      var text1='';
      var editedText= (new DOMParser).parseFromString(text, "text/html").documentElement.textContent;
      var Nnyutt_array = editedText.split('');
      var finaltext_array = [];
      var vowel_underlined = false;
      if (text.includes("'")){
        for (i = 0; i < Nnyutt_array.length; i++) {
          if (Nnyutt_array[i] == "'")
          {
            Nnyutt_array.splice(i,1);
            if ("aeiouøæåy".indexOf(Nnyutt_array[i]) != -1) {
              vowel_underlined = true;
            }
            // Nnyutt_array[i] = final_text + "<u class = "+ this.addClass( Nnyutt_array[i])+">" + Nnyutt_array[i] + "</u>";
            finaltext_array.push("<u class = "+ this.addClass( Nnyutt_array[i])+">" + Nnyutt_array[i] + "</u>");

              }  else {
                finaltext_array.push(Nnyutt_array[i]);
              }
            }
            final_text = finaltext_array.join("");
            var newTextUtt=text.replace(editedText, final_text);
            text1 = newTextUtt;
          }

      else if (text.includes(":")) {
        for (var i = Nnyutt_array.length - 1; i >= 0; i--) {
          if (
            (Nnyutt_array[i] == "a" ||
              Nnyutt_array[i] == "e" ||
              Nnyutt_array[i] == "i" ||
              Nnyutt_array[i] == "o" ||
              Nnyutt_array[i] == "u" ||
              Nnyutt_array[i] == "ø" ||
              Nnyutt_array[i] == "æ" ||
              Nnyutt_array[i] == "å" ||
              Nnyutt_array[i] == "y") &&
              Nnyutt_array[i + 1] == ":"
          ) {
            finaltext_array.push("<u class = "+ this.addClass( Nnyutt_array[i])+">" + Nnyutt_array[i] + "</u>");
          } else {
            finaltext_array.push(Nnyutt_array[i]);
          }
        }
        final_text = finaltext_array.reverse().join("");
      } else {
        const count_vowel = text.match(/[aeiouøæåy]/gi).length;
        for (i = 0; i < Nnyutt_array.length; i++) {
          if (
            (Nnyutt_array[i] == "a" ||
              Nnyutt_array[i] == "e" ||
              Nnyutt_array[i] == "i" ||
              Nnyutt_array[i] == "o" ||
              Nnyutt_array[i] == "u" ||
              Nnyutt_array[i] == "ø" ||
              Nnyutt_array[i] == "æ" ||
              Nnyutt_array[i] == "å" ||
              Nnyutt_array[i] == "y") &&
              vowel_underlined == false && count_vowel >1
          ) {
            final_text = final_text + "<u class = "+ this.addClass( Nnyutt_array[i])+">" + Nnyutt_array[i] + "</u>";
            vowel_underlined = true;
          } else {
            final_text = final_text + Nnyutt_array[i];
          }
        }
      }

      final_text = final_text.replace(/\\/g, "");
      final_text = final_text.replace(".", "");
      return "/" + final_text + "/";
    },
    addClass (letter) {
      if (letter == 'y'){
        return 'underline_position';
      } else{
        return '';
      }
    }
    //#endregion
  }
};
</script>
<style>
</style>
